import FinancingHelper from "../../../../helpers/FinancingHelper";

export default function ItemDiv({ item }) {
  return (
    <div className="flex items-center mb-2">
      <div
        className="whitespace-nowrap flex items-center pt-4"
        style={{ minWidth: "40em" }}
      >
        <label>{item?.name}</label>
      </div>
      {item?.array?.map((obj) => (
        <div style={{ minWidth: "10em" }}>
          <label
            className={
              obj?.disabled
                ? "disabled flex items-center"
                : "flex items-center"
            }
          >
            {FinancingHelper.bracketFormatter(obj?.value)}
          </label>
        </div>
      ))}
    </div>
  );
}
